import { render, staticRenderFns } from "./AddColorModal.vue?vue&type=template&id=22ca8492&scoped=true"
import script from "./AddColorModal.vue?vue&type=script&lang=js"
export * from "./AddColorModal.vue?vue&type=script&lang=js"
import style0 from "./AddColorModal.vue?vue&type=style&index=0&id=22ca8492&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ca8492",
  null
  
)

export default component.exports